import type { JourPlanning } from '../../lib/api/types'
import { formatDate, formatHeure } from '../../lib/formatters'

/**
 * Alerte de couverture (règle R3).
 *
 * **Un avertissement, jamais un blocage.** Le §7 est explicite : le logiciel
 * signale, il ne décide pas à la place du cabinet. Un cabinet qui tourne à un
 * infirmier un mercredi après-midi le sait déjà ; l'empêcher d'enregistrer son
 * planning ne l'aiderait pas.
 */
export function BandeauCouverture({
  jours,
  onAller,
}: {
  jours: JourPlanning[]
  onAller: (date: string, heure: string) => void
}) {
  const alertes = jours.flatMap((jour) =>
    jour.couverture.map((creneau) => ({ jour, creneau })),
  )

  if (alertes.length === 0) return null

  return (
    <div
      className="rounded-lg border border-amber-200 bg-amber-50 px-4 py-3"
      role="status"
      aria-label="Alertes de couverture"
    >
      <p className="text-sm font-medium text-amber-900">
        Couverture insuffisante sur {alertes.length} créneau{alertes.length > 1 ? 'x' : ''}
      </p>
      <ul className="mt-2 flex flex-wrap gap-2">
        {alertes.slice(0, 8).map(({ jour, creneau }) => (
          <li key={`${jour.date}-${creneau.heure_debut}`}>
            <button
              type="button"
              onClick={() => onAller(jour.date, creneau.heure_debut)}
              className="rounded-full border border-amber-300 bg-white px-3 py-1 text-xs text-amber-900 hover:bg-amber-100 focus:outline-none focus-visible:ring-2 focus-visible:ring-amber-500"
            >
              {jour.libelle} {formatDate(jour.date).slice(0, 5)},{' '}
              {formatHeure(creneau.heure_debut)}–{formatHeure(creneau.heure_fin)} —{' '}
              {creneau.effectif_present} infirmier{creneau.effectif_present > 1 ? 's' : ''} présent
              {creneau.effectif_present > 1 ? 's' : ''}, {creneau.effectif_requis} requis
            </button>
          </li>
        ))}
        {alertes.length > 8 ? (
          <li className="self-center text-xs text-amber-800">
            et {alertes.length - 8} autre{alertes.length - 8 > 1 ? 's' : ''}
          </li>
        ) : null}
      </ul>
    </div>
  )
}
